// extracted by mini-css-extract-plugin
export default {"cls1":"KyH4bUCIoVd3zth1CRB5","cls2":"hjAM2Q8Dce6xBIQ0l4ez KyH4bUCIoVd3zth1CRB5"};